module.exports = __webpack_public_path__ + "img/tab41.a4c0d1c2.png";